import { Theme, makeStyles } from '@material-ui/core'
import Button from 'elements/button/Button'
import { useTranslate } from 'ra-core'
import React from 'react'
import { AvailableFinanceIntegrationType } from 'types/orgs'

type PropTypes = {
  integration: AvailableFinanceIntegrationType
  onClick: () => void
  loading: boolean
  label: string
}

const useStyles = makeStyles<Theme, { integration: AvailableFinanceIntegrationType }>((theme) => ({
  buttonBase: {
    marginBottom: '10px !important',
    marginTop: '20px !important',
    width: '100%',
    backgroundColor: ({ integration }) =>
      `${integration?.banner_content?.theme_color} !important` || '#ffda00 !important',
    color: ({ integration }) => `${integration?.banner_content?.font_color} !important` || '#fff !important',
    borderWidth: '0px',
    '&:hover': {
      background: ({ integration }) =>
        `${integration?.banner_content?.theme_color_dark} !important` || '#ffda00 !important',
    },
    '&:focus': {
      boxShadow: 'none !important',
    },
  },
}))

const IntegrationBrandedButton: React.FC<PropTypes> = (props) => {
  const translate = useTranslate()
  const classes = useStyles({ integration: props.integration })

  return (
    <Button
      variant="text"
      color="default"
      className={classes.buttonBase}
      onClick={props.onClick}
      label={translate(props.label)}
      loading={props.loading}
    />
  )
}
export default IntegrationBrandedButton
